import React, { useState } from "react";
import { KEY } from "@/react/components/table/useTableMutations";
import { PencilInBoxIcon } from "@8x8/oxygen-icon";
import { AddressSelector } from "@/react/features/smp/address-management/AddressSelector";
import { Button } from "@/react/styled";
import ColumnSetterInfoContainer from "@/react/features/styled/ColumnSetterInfoContainer";
import ColumnSetterActionContainer from "@/react/features/styled/ColumnSetterActionContainer";
import InlineBlock from "@/react/features/styled/InlineBlock";

export function addressSelectorColumnSetterFactory(addressIdColumnKey) {
  return ({ column, table, rows }) => {
    const { schema, updateRows } = table.options.meta;
    const columnId = column.id;
    const firstAddress = rows[0]?.getValue(columnId);
    const firstAddressId = rows[0]?.getValue(addressIdColumnKey);

    const [address, setAddress] = useState(firstAddress);

    const [addressId, setAddressId] = useState(firstAddressId);

    const onSet = () => {
      const rowKeys = rows.map((row) => row.original[KEY]);
      const patchMap = new Map([
        [addressIdColumnKey, addressId],
        [columnId, address],
      ]);
      updateRows(rowKeys, patchMap, schema);
    };

    return (
      <>
        <ColumnSetterInfoContainer>
          <PencilInBoxIcon size={18} />
          <InlineBlock>
            Set value for{" "}
            <span>
              {rows.length} {rows.length === 1 ? "row" : "rows"}
            </span>
          </InlineBlock>
        </ColumnSetterInfoContainer>
        <ColumnSetterActionContainer>
          <AddressSelector
            addressId={addressId}
            address={address}
            onChangeAddressId={setAddressId}
            onChangeAddress={setAddress}
            errors={[]}
          />
          <Button
            marginLeft={16}
            variant="primary"
            size="small"
            onClick={onSet}
          >
            Set
          </Button>
        </ColumnSetterActionContainer>
      </>
    );
  };
}
